export default __webpack_public_path__ + "static/media/Sgins and Wayfiding SOBH.8582484a.jpg";